import {
	InjectionToken
} from '@angular/core';

export const COOKIES_CONFIG = new InjectionToken('cookies.config');

export const CookiesConfig: any = {
};
